import React from "react";
import { UniPageProcessHero } from "@modules/study/unipages/process";
import UniPageBookingSection from "@modules/study/unipages/section_booking";
import UniPageSectionWithDropdown from "@modules/study/unipages/section_with_dropdown";
import { getAssets } from "@unisearch/helpers";
import { LayoutUniversityPage } from "@unisearch/theme/layout";

const screenData = [
  {
    id: 1,
    title: "Profile-match",
    description:
      "AI-driven systems and regional experts drive engagement of bonafide prospects with the highest likelihood of conversion to universities",
  },
  {
    id: 2,
    title: "Access diverse markets",
    description:
      "UniSearch combines the insight of regional experts in distinct locales with modern technology to provide university partners access to promising prospects in diverse source markets, all through a single platform",
  },
];
const connectData = [
  {
    id: 1,
    title: "Regional Expertise",
    description:
      "Partner with a dedicated regional team to leverage local expertise in distinct source markets",
  },
  {
    id: 2,
    title: "Direct Student Engagement",
    description:
      "Connect with students one-to-one through real-time chat, create avenues to forge meaningful connections, offer personalised solutions, and boost conversion rates",
  },
  {
    id: 3,
    title: "International Student Mentors",
    description:
      "Nominate international students to represent your university as UniSearch Mentors, engaging prospects interested in learning more about the student experience",
  },
  {
    id: 4,
    title: "University Collaborations",
    description:
      "Our regional teams act as liaisons to negotiate collaborative opportunities between your institution and local universities in source markets",
  },
  {
    id: 5,
    title: "Brand Management",
    description:
      "Manage your brand voice through complete access on our platform, from updating university and course profiles to uploading rich media and blog posts to engage students",
  },
  {
    id: 6,
    title: "Virtual Fairs",
    description:
      "Engage with students in emerging source markets through unique opportunities to participate in UniSearch-hosted virtual fairs",
  },
];

const convertData = [
  {
    id: 1,
    title: "Data-Driven Decision Making",
    description:
      "Effectively allocate resources, minimise risk, and create informed recruitment strategies with market-specific analytics and insight into target audience consumption and behaviour",
  },
  {
    id: 2,
    title: "Streamlined Application Pipeline",
    description:
      "UniSearch speeds up application timeline and efficacy by integrating every step of the process on a single platform",
  },
  {
    id: 3,
    title: "Tracking and Follow-Up",
    description:
      "Ensure application timelines are met and completion rates boosted through real-time tracking and direct follow-up channels",
  },
];

const University = () => {
  return (
    <LayoutUniversityPage
      title="International Student Recruitment Strategy | UniSearch for University"
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/university/processes`}
    >
      <UniPageProcessHero />

      <UniPageSectionWithDropdown
        data={screenData}
        imageLeft
        image={getAssets("assets/images/unipage/screen.png")}
        title="Screen"
        description="UniSearch optimises the time and resources university partners spend on locating their best-fit prospects, ensuring they have access to the right audience from the get-go."
      />

      <UniPageSectionWithDropdown
        data={connectData}
        image={getAssets("assets/images/unipage/connect.png")}
        title="Connect"
        description="Creating meaningful connections is at the heart of successful student recruitment. UniSearch creates multi-channel networks to enable collaboration between university partners and vital stakeholders in student recruitment."
      />
      <UniPageSectionWithDropdown
        imageLeft
        data={convertData}
        image={getAssets("assets/images/unipage/convert.png")}
        title="Convert"
        description="Our integrated digital platform optimises student recruitment for success. We streamline information, processes, and access through a single platform to enhance recruitment outcomes for our university partners."
      />
      <UniPageBookingSection />
    </LayoutUniversityPage>
  );
};

export default University;
